import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, Button } from './ui';
export const Hero = () => {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 px-6 overflow-hidden bg-cream-light" data-id="element-84">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cream-dark/30 rounded-bl-full -z-10 blur-3xl opacity-50" data-id="element-85"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-sage-light/40 rounded-tr-full -z-10 blur-3xl opacity-50" data-id="element-86"></div>

      <div className="max-w-6xl mx-auto" data-id="element-87">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-88">
          <div className="flex-1 text-center lg:text-left" data-id="element-89">
            <FadeIn data-id="element-90">
              <span className="inline-block py-1 px-3 rounded-full bg-gold-light text-brown-light text-sm font-bold tracking-wider uppercase mb-6" data-id="element-91">
                Para mujeres 50+
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-92">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-93">
                Plan de 21 Días de Vitalidad Menopáusica: <br data-id="element-94" />
                <span className="text-gold italic font-normal" data-id="element-95">
                  El Método de Micro-Sincronización
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-96">
              <p className="text-lg md:text-xl text-brown-light mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-97">
                Recupera tu energía matutina, elimina la neblina mental y vuelve
                a sentirte dueña de tu cuerpo en solo 3 semanas.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-98">
              <Button className="mx-auto lg:mx-0" href="#precio" data-id="element-99">
                ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
              </Button>
              <p className="mt-4 text-sm text-brown-light/70 flex items-center justify-center lg:justify-start gap-2" data-id="element-100">
                <svg className="w-4 h-4 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-101">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-102" />
                </svg>
                Pago seguro. Acceso instantáneo.
              </p>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none relative" data-id="element-103">
            <FadeIn delay={0.4} data-id="element-104">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brown/10 aspect-[4/5] lg:aspect-auto lg:h-[600px]" data-id="element-105">
                <img src="https://cdn.magicpatterns.com/uploads/9G6aWdx1gpXNMEYmywpptz/Plan_21_Dias_de_Vitalidad_Menopausica.png" alt="Plan de 21 Días de Vitalidad Menopáusica en una tablet" className="w-full h-full object-cover" data-id="element-106" />
                <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent mix-blend-multiply" data-id="element-107"></div>
              </div>

              {/* Floating badge */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.8,
              type: 'spring'
            }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl flex items-center gap-4" data-id="element-108">
                <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center text-sage" data-id="element-109">
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-110">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-111" />
                  </svg>
                </div>
                <div data-id="element-112">
                  <p className="text-sm font-bold text-brown" data-id="element-113">
                    Energía Estable
                  </p>
                  <p className="text-xs text-brown-light" data-id="element-114">En solo 21 días</p>
                </div>
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};